
<div class="overflow-x-hidden">
    <!-- TopAppBar -->
    <!-- <header class="fixed top-0 w-full bg-white/90 backdrop-blur-md border-b border-surface-variant z-50 h-20 transition-all duration-300">
    <div class="flex justify-between items-center px-margin-mobile md:px-margin-desktop h-full w-full max-w-container-max mx-auto">
    <div class="flex items-center gap-2">
    <img src="assets/icons/account_balance.svg" alt="Bajaj Capital" class="w-7 h-7 object-contain" />
    <span class="font-headline-md text-headline-md font-extrabold tracking-tight text-on-surface uppercase">Bajaj Capital</span>
    </div>
    <div class="hidden md:flex gap-gutter items-center">
    <a class="text-primary font-bold border-b-2 border-primary pb-1 font-label-md text-label-md" href="#">Strategic View</a>
    <a class="text-on-surface-variant font-label-md text-label-md hover:text-primary transition-colors duration-200" href="#performance">Portfolio</a>
    <a class="text-on-surface-variant font-label-md text-label-md hover:text-primary transition-colors duration-200" href="#goals">Advisory</a>
    </div>
    </div>
    </header> -->
    <main>
    <!-- Hero Section with Integrated Form -->
    <section class="relative flex items-center overflow-hidden py-24 px-margin-mobile md:px-margin-desktop min-h-[700px]">
    <div class="relative z-10 w-full max-w-container-max mx-auto">
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
    <!-- Left Column: Content -->
    <div class="lg:col-span-6 flex flex-col gap-8">
    <div class="inline-flex items-center gap-2 px-3 py-1 bg-surface-container-high border border-outline-variant rounded-full w-fit">
    <img src="assets/icons/verified.svg" alt="verified" class="w-4 h-4 object-contain" />
    <span class="font-label-md text-label-md text-on-surface uppercase tracking-widest"><span style="letter-spacing: 1.2px;">Heritage Trust</span></span>
    </div>
    <h1 class="font-headline-xl text-headline-xl text-on-surface tracking-tight leading-tight">
                            Your Legacy, <br/><span class="text-primary">Our Technical Precision</span>
    </h1>
    <p class="font-body-lg text-body-lg text-on-surface-variant max-w-lg">
                            Leveraging 60+ years of institutional heritage to build future-proof financial frameworks for elite families and forward-thinking investors.
                        </p>
    <div class="flex items-center gap-8 mt-4">
    <div class="flex flex-col">
    <span class="font-headline-md text-headline-md text-on-surface">60+</span>
    <span class="font-label-md text-label-md text-on-surface-variant uppercase">Years Experience</span>
    </div>
    <div class="w-px h-12 bg-outline-variant/30"></div>
    <div class="flex flex-col">
    <span class="font-headline-md text-headline-md text-on-surface">₹20K+ Cr</span>
    <span class="font-label-md text-label-md text-on-surface-variant uppercase">Assets Managed</span>
    </div>
    </div>
    </div>
    <!-- Right Column: Consultation Form -->
    <div class="lg:col-span-6">
    <div class="bg-white border border-surface-variant p-8 md:p-10 rounded-xl shadow-xl relative overflow-hidden group" *ngIf="isLeadFormVisible">
    <div class="absolute top-0 left-0 w-1.5 h-full bg-primary"></div>
    <div class="mb-8">
    <h2 class="font-headline-md text-headline-md text-on-surface mb-2">Request Strategic Consultation</h2>
    <p class="font-body-md text-body-md text-on-surface-variant">Fill in your details to receive a personalized plan today.</p>
    </div>
    <form class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="space-y-1.5">
    <label class="font-label-md text-label-md text-on-surface-variant uppercase tracking-widest">Full Name</label>
    <input name="name" [(ngModel)]="name"
    class="w-full bg-surface-container-lowest border border-surface-variant focus:border-primary focus:ring-1 focus:ring-primary rounded p-3 text-on-surface font-body-md transition-all outline-none" placeholder="Johnathan Smith" 
    type="text" (blur)="removeErrorMsg('name')"
    maxlength="40" 
    inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
    (keydown)="alphaOnly($event)">
        <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
            Invalid full name
        </div>
        <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
            Full name is mandatory
        </div>
    </div>
    <div class="space-y-1.5">
    <label class="font-label-md text-label-md text-on-surface-variant uppercase tracking-widest">Email Address</label>
    <input name="email" [(ngModel)]="email"
    class="w-full bg-surface-container-lowest border border-surface-variant focus:border-primary focus:ring-1 focus:ring-primary rounded p-3 text-on-surface font-body-md transition-all outline-none" placeholder="jsmith@corporate.com" 
    type="email" maxlength="50" (blur)="removeErrorMsg('email')">
        <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
            Invalid email id
        </div>
        <div class="errormsg" *ngIf="emailValidateMessage == 'required'">
            Email id is mandatory
        </div>
    </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="space-y-1.5">
    <label
    class="font-label-md text-label-md text-on-surface-variant uppercase tracking-widest">Phone Number</label>
    <input class="w-full bg-surface-container-lowest border border-surface-variant focus:border-primary focus:ring-1 focus:ring-primary rounded p-3 text-on-surface font-body-md transition-all outline-none" placeholder="+91 00000 00000" 
    type="tel" minlength="10" maxlength="10" name="mobile" [(ngModel)]="mobile"
    pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')"
    inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
    (keypress)="numbersOnly($event)">
        <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
            10 digit mobile number is mandatory
        </div>
        <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
            Invalid mobile number
        </div>
        <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
            Mobile number is mandatory
        </div>
    </div>

    <div class="space-y-2">
      <label class="font-label-md text-label-md text-on-surface-variant uppercase tracking-widest">
        Which age group are you in?
      </label>
    
      <div class="relative">
        <select
          name="age"
          [(ngModel)]="age"
          (blur)="removeErrorMsg('age')"
          class="w-full h-12 rounded-xl border border-surface-variant bg-surface-container-lowest px-4 pr-12 text-on-surface font-body-md outline-none appearance-none transition-all duration-200 focus:border-primary focus:ring-2 focus:ring-primary/20 hover:border-primary cursor-pointer">
    
          <option value="" disabled>Select your age group</option>
          <option value="18-24">18 - 24 years</option>
          <option value="25-30">25 - 30 years</option>
          <option value="31-40">31 - 40 years</option>
          <option value="41-50">41 - 50 years</option>
          <option value="51+">51+ years</option>
        </select>
      </div>
    
      <div class="errormsg" *ngIf="ageValidateMessage == 'invalid'">
        Invalid age
      </div>
    
      <div class="errormsg" *ngIf="ageValidateMessage == 'required'">
        Age is mandatory
      </div>
    </div>

    <div class="space-y-2 relative">
      <label class="font-label-md text-label-md text-on-surface-variant uppercase tracking-widest">
        Pincode
      </label>
    
      <div class="relative">
        <input
          class="w-full h-12 rounded-xl border border-surface-variant bg-surface-container-lowest px-4 text-on-surface font-body-md outline-none transition-all duration-200 focus:border-primary focus:ring-2 focus:ring-primary/20 hover:border-primary"
          type="text"
          autocomplete="off"
          id="pincode"
          name="pincode"
          [(ngModel)]="pincodeDisplay"
          placeholder="Enter pincode"
          minlength="6"
          maxlength="6"
          (click)="openSuggestionBox($event, 'form')"
          (blur)="hideSuggestionDiv('form')"
          (keyup)="getPincodeList($event, 'form')"
          (keypress)="numberspincode($event)"
          (blur)="removeErrorMsg('pincode')">
    
        <div class="pointer-events-none absolute inset-y-0 right-4 flex items-center text-gray-500">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
    
        <div
          *ngIf="hideSuggestion && pincodeArr?.length"
          class="absolute z-50 mt-2 w-full overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg max-h-60 overflow-y-auto">
    
          <button
            type="button"
            *ngFor="let pin of pincodeArr"
            class="w-full px-4 py-3 text-left hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0"
            (mousedown)="setpincode(pin, 'form')">
    
            <div class="font-medium text-gray-900">
              {{ pin.pincode }}
            </div>
            <div class="text-sm text-gray-500">
              {{ pin.cityname }}
            </div>
          </button>
        </div>
      </div>
    
      <div class="errormsg" *ngIf="pinValidateMessage == 'invalid'">
        Invalid pincode
      </div>
    
      <div class="errormsg" *ngIf="pinValidateMessage == 'required'">
        Pincode is mandatory
      </div>
    
      <div class="errormsg" *ngIf="pinValidateMessage == 'notselected'">
        Pincode selection from the list is mandatory
      </div>
    </div>

    <div class="relative" tabindex="0" (focusout)="onFocusOut($event)">
      <label class="font-label-md text-label-md text-on-surface-variant uppercase tracking-widest">Primary Interest</label>
      <div
        class="w-full h-12 rounded-xl border border-surface-variant px-4 flex items-center justify-between cursor-pointer"
        (click)="showGoals = !showGoals" (blur)="removeErrorMsg('goal')">
    
        <span *ngIf="selectedGoals.length == 0">
          Select up to 3 interests
        </span>
    
        <span *ngIf="selectedGoals.length > 0">
          {{ selectedGoals[0] }}
          <span *ngIf="selectedGoals.length > 1">
            +{{ selectedGoals.length - 1 }}
          </span>
        </span>
    
        <img src="assets/icons/expand_more.svg" alt="expand" class="w-5 h-5 object-contain" />
      </div>
    
      <div
        *ngIf="showGoals"
        class="absolute z-50 mt-2 w-full bg-white border rounded-xl shadow-lg max-h-56 overflow-y-auto">
    
        <label
          *ngFor="let option of goalOptions"
          class="flex items-center px-4 py-3 hover:bg-gray-50">
    
          <input
            type="checkbox"
            [checked]="selectedGoals.includes(option.value)"
            [disabled]="!selectedGoals.includes(option.value) && selectedGoals.length >= 3"
            (change)="toggleGoal(option.value)"
            class="mr-3">
    
          {{ option.label }}
    
        </label>
    
      </div>
      <div class="errormsg" *ngIf="goalValidateMessage == 'required'">
          This field is mandatory
      </div>
    </div>

    <div class="space-y-1.5 relative">
      <label
      class="font-label-md text-label-md text-on-surface-variant uppercase tracking-widest">Do you have personal/family health insurance outside employer cover?</label>
      <select  name="healthCover" [(ngModel)]="healthCover"
      class="w-full bg-surface-container-lowest border border-surface-variant focus:border-primary focus:ring-1 focus:ring-primary rounded p-3 text-on-surface font-body-md transition-all appearance-none outline-none"
      (blur)="removeErrorMsg('healthCover')">
          <option value="" selected disabled>Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
          <option value="Not Sure">Not Sure</option>
      </select>
      <!-- <div class="errormsg" *ngIf="healthValidateMessage == 'required'">
          This field is mandatory
      </div> -->
    </div>

    <div class="space-y-1.5 relative">
      <label
      class="font-label-md text-label-md text-on-surface-variant uppercase tracking-widest">How would you prefer to connect?</label>
      <select name="meeting_mode" [(ngModel)]="meeting_mode"
      class="w-full bg-surface-container-lowest border border-surface-variant focus:border-primary focus:ring-1 focus:ring-primary rounded p-3 text-on-surface font-body-md transition-all appearance-none outline-none"
      (blur)="removeErrorMsg('meeting_mode')">
          <option value="" selected disabled>Select</option>
          <option value="Google Meet">Google Meet</option>
          <option value="Normal Call">Normal Call</option>
      </select>
      <div class="errormsg" *ngIf="modeValidateMessage == 'required'">
          This field is mandatory
      </div>
    </div>




  <!-- Calendar Popup Modal -->
  <div class="calendar-popup-overlay" *ngIf="isCalendarPopupVisible">
    <div class="calendar-popup-content" (click)="$event.stopPropagation()">
      <div class="calendar-popup-header">
        You’re one step away. Choose a convenient time for your complimentary planning session.
        <button class="close-btn" (click)="closeCalendarPopup()">&times;</button>
      </div>

      <div class="calendar-popup-body">
        <!-- Date Selection -->
        <div class="calendar-selection-wrapper">
          <div class="date-selection-section">
            <h4>Select Date</h4>

            <!-- Calendar Header -->
            <div class="calendar-header">
              <div class="calendar-nav">
                <button class="nav-btn" (click)="previousMonth()">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <span class="current-month-year">{{currentMonth.format('MMMM YYYY')}}</span>

                <button class="nav-btn" (click)="nextMonth()">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- Calendar Grid -->
            <div class="calendar-grid">
              <!-- Days of Week Header -->
              <div class="calendar-weekdays">
                <div class="weekday" *ngFor="let day of ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']">
                  {{day}}
                </div>
              </div>

              <!-- Calendar Days -->
              <div class="calendar-days">
                <div *ngFor="let day of calendarDays" class="calendar-day" [class.current-month]="day.isCurrentMonth"
                  [class.other-month]="!day.isCurrentMonth && day.isDisabled" [class.today]="day.isToday" [class.selected]="day.isSelected"
                  [class.disabled]="day.isDisabled" [class.available]="day.isAvailable"
                  (click)="selectCalendarDate(day)">
                  {{day.date.format('D')}}
                </div>
              </div>
            </div>

            <!-- Calendar Actions -->
            <div class="calendar-actions">
              <button class="clear-btn" (click)="clearSelection()">CLEAR</button>
            </div>
          </div>

          <!-- Time Slot Selection -->
          <div class="time-selection-section" [class.has-selection]="!!selectedDate" *ngIf="selectedDate">
            <div class="time-selection-header">
              <h4>Select Time Slot</h4>
            </div>
            <div class="time-slots">
              <div *ngFor="let timeSlot of availableTimeSlots" class="time-slot"
                [class.selected]="selectedTimeSlot === timeSlot" (click)="selectTimeSlot(timeSlot)">
                {{timeSlot}}
              </div>
            </div>

            <!-- Confirm Button -->
            <div class="popup-actions" *ngIf="isAppointmentReady()">
              <p class="_popmsg">{{popupmessage}}</p>
              <button class="btn btn-primary confirm-btn" (click)="confirmAppointment()" [disabled]="isButtonDisabled">
                Confirm Appointment
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>



    </div>

    <div class="pt-4">
    <button   class="w-full py-4 bg-primary text-on-primary font-bold font-label-md text-label-md rounded-xl
    hover:opacity-90 shadow-lg shadow-primary/20 transition-all
    flex items-center justify-center gap-2 group-hover:scale-[1.01]
    disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none disabled:hover:opacity-50 disabled:group-hover:scale-100" type="submit" [disabled]="!checkedTerms" (click)="PostData()">
        INITIATE CONSULTATION
    <img src="assets/icons/send.svg" alt="send" class="w-5 h-5 object-contain transition-transform group-hover:translate-x-1" />
    </button>
    </div>
    <p class="text-center font-label-md text-label-md text-on-surface-variant">
      <input
        type="checkbox"
        class="form-check-input checkbox2"
        id="checkout1"
        [(ngModel)]="checkedTerms"
        name="check"
      />
     I agree to be contacted by Bajaj Capital regarding my selected financial needs.
    </p>
    </form>

    </div>
    
    <div class="bg-white border border-surface-variant p-8 md:p-10 rounded-xl shadow-xl relative overflow-hidden flex flex-col items-center justify-center text-center min-h-[480px]" *ngIf="isThanksVisible">
        <div class="absolute top-0 left-0 w-1.5 h-full bg-primary"></div>
        <div class="mb-8 inline-flex items-center justify-center w-24 h-24 rounded-full bg-surface-container-high border border-outline-variant shadow-sm">
            <img src="assets/icons/verified.svg" alt="verified" class="w-12 h-12 object-contain" />
        </div>
        <h2 class="font-headline-xl text-headline-xl text-on-surface mb-4">Thank You!</h2>
        <p class="font-body-lg text-body-lg text-on-surface-variant max-w-sm mx-auto">A member of our care team will get in touch with you shortly.</p>
    </div>
    </div>
    </div>
    </div>
    </section>
    <!-- Trust & Partnership Section -->
    <section class="bg-surface-container-low py-32 border-y border-surface-variant" id="performance">
    <div class="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
    <div class="space-y-10">
    <h2 class="font-headline-lg text-headline-lg text-on-surface">Institutional Core. <br/>Elite Performance.</h2>
    <div class="accent-bar"></div>
    <p class="font-body-md text-body-md text-on-surface-variant leading-relaxed text-lg">
                        Our strategic methodology is built upon Bajaj Capital's 50-year legacy of financial stewardship. We provide the stability of a financial titan with the precision of elite institutional portfolio management.
                    </p>
    <div class="grid grid-cols-2 gap-8">
    <div class="p-8 bg-white rounded-xl border border-surface-variant shadow-sm">
    <span class="font-headline-md text-headline-md text-primary block mb-2">60+</span>
    <span class="font-label-md text-label-md text-on-surface-variant uppercase">Years of Trust</span>
    </div>
    <div class="p-8 bg-white rounded-xl border border-surface-variant shadow-sm">
    <span class="font-headline-md text-headline-md text-primary block mb-2">₹20K+ Cr</span>
    <span class="font-label-md text-label-md text-on-surface-variant uppercase">Assets Managed</span>
    </div>
    </div>
    </div>
    <div class="relative group">
    <div class="absolute -inset-2 bg-gradient-to-r from-primary to-primary-container rounded-xl blur opacity-10 group-hover:opacity-25 transition duration-1000"></div>
    <img alt="Institutional Architecture" class="relative rounded-xl w-full h-[600px] object-cover transition duration-700 shadow-2xl" src="../../assets/images/Novus Tower.png"/>
    </div>
    </div>
    </section>
    <!-- Strategic Life Goals Section -->
    <section class="py-32 px-margin-mobile md:px-margin-desktop bg-surface" id="goals">
    <div class="max-w-container-max mx-auto">
    <div class="text-center mb-24">
    <h2 class="font-headline-lg text-headline-lg text-on-surface mb-6">Strategic Life Goals</h2>
    <p class="font-body-md text-body-md text-on-surface-variant max-w-2xl mx-auto text-lg">Engineering financial outcomes through data-driven planning and institutional-grade modeling.</p>
    </div>
    <!-- Bento-style Grid for Goals -->
    <div class="grid grid-cols-1 md:grid-cols-6 gap-gutter">
    <!-- Education -->
    <div class="md:col-span-3 performance-tile p-12 rounded-xl flex flex-col justify-between group h-[400px]">
    <div>
    <img src="assets/icons/school.svg" alt="school" class="w-12 h-12 mb-8 block object-contain" />
    <h3 class="font-headline-md text-headline-md text-on-surface mb-4">Education Planning</h3>
    <p class="font-body-md text-body-md text-on-surface-variant text-lg">Global academic pathways secured with currency-hedged investment structures.</p>
    </div>
    <div class="mt-12 flex justify-between items-center border-t border-outline-variant/30 pt-6">
    <span class="font-label-md text-label-md text-primary uppercase font-bold">Legacy First</span>
    <img src="assets/icons/arrow_right_alt.svg" alt="arrow" class="w-6 h-6 object-contain group-hover:translate-x-2 transition-transform" />
    </div>
    </div>
    <!-- Retirement -->
    <div class="md:col-span-3 performance-tile p-12 rounded-xl flex flex-col justify-between group h-[400px]">
    <div>
    <img src="assets/icons/nightlight.svg" alt="retirement" class="w-12 h-12 mb-8 block object-contain" />
    <h3 class="font-headline-md text-headline-md text-on-surface mb-4">Institutional Retirement</h3>
    <p class="font-body-md text-body-md text-on-surface-variant text-lg">Transition from wealth accumulation to high-yield sustainable distributions.</p>
    </div>
    <div class="mt-12 flex justify-between items-center border-t border-outline-variant/30 pt-6">
    <span class="font-label-md text-label-md text-primary uppercase font-bold">Infinite Horizon</span>
    <img src="assets/icons/arrow_right_alt.svg" alt="arrow" class="w-6 h-6 object-contain group-hover:translate-x-2 transition-transform" />
    </div>
    </div>
    <!-- Family Milestones -->
    <div class="md:col-span-2 performance-tile p-10 rounded-xl flex flex-col group hover:shadow-lg">
    <img src="assets/icons/favorite.svg" alt="family milestones" class="w-8 h-8 mb-6 block object-contain" />
    <h3 class="font-headline-sm text-headline-sm text-on-surface mb-3">Family Milestones</h3>
    <p class="font-body-md text-body-md text-on-surface-variant">Strategic liquidity for life's most significant celebrations and transitions.</p>
    </div>
    <!-- Real Estate -->
    <div class="md:col-span-2 performance-tile p-10 rounded-xl flex flex-col group hover:shadow-lg">
    <img src="assets/icons/domain.svg" alt="real estate" class="w-8 h-8 mb-6 block object-contain" />
    <h3 class="font-headline-sm text-headline-sm text-on-surface mb-3">Real Estate Assets</h3>
    <p class="font-body-md text-body-md text-on-surface-variant">Structuring high-value acquisitions with optimized debt-equity ratios.</p>
    </div>
    <!-- Custom Goals -->
    <div class="md:col-span-2 performance-tile p-10 rounded-xl bg-surface-container-low flex flex-col group border-dashed border-2 border-outline/30">
    <img src="assets/icons/add_circle.svg" alt="custom goals" class="w-8 h-8 mb-6 block object-contain" />
    <h3 class="font-headline-sm text-headline-sm text-on-surface mb-3">Custom Goals</h3>
    <p class="font-body-md text-body-md text-on-surface-variant italic">Define your unique vision for wealth, legacy, and philanthropic impact.</p>
    </div>
    </div>
    </div>
    </section>
    </main>
    <!-- Footer -->
    <!-- <footer class="bg-surface-dim w-full py-20 border-t border-surface-variant">
    <div class="flex flex-col md:flex-row justify-between items-start px-margin-mobile md:px-margin-desktop w-full max-w-container-max mx-auto gap-16">
    <div class="space-y-6 max-w-sm">
    <div class="flex items-center gap-2">
    <img src="assets/icons/account_balance.svg" alt="Bajaj Capital" class="w-7 h-7 object-contain" />
    <span class="font-headline-md text-[22px] font-bold text-on-surface uppercase">Bajaj Capital</span>
    </div>
    <p class="font-body-md text-body-md text-on-surface-variant leading-relaxed">
                    Providing elite financial stewardship and strategic wealth architecture since 1964. Institutional strength meets performance excellence.
                </p>
    <div class="pt-4 border-t border-outline-variant/20">
    <p class="font-label-md text-label-md text-on-surface-variant">© 2024 Bajaj Capital Ltd. All Rights Reserved.</p>
    </div>
    </div>
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-16">
    <div class="flex flex-col gap-5">
    <p class="font-label-lg text-label-lg text-on-surface uppercase tracking-widest font-bold mb-2">Legal</p>
    <a class="text-on-surface-variant font-body-md text-body-md hover:text-primary transition-colors" href="#">Privacy Policy</a>
    <a class="text-on-surface-variant font-body-md text-body-md hover:text-primary transition-colors" href="#">Terms of Service</a>
    <a class="text-on-surface-variant font-body-md text-body-md hover:text-primary transition-colors" href="#">Disclosures</a>
    </div>
    <div class="flex flex-col gap-5">
    <p class="font-label-lg text-label-lg text-on-surface uppercase tracking-widest font-bold mb-2">Advisory</p>
    <a class="text-on-surface-variant font-body-md text-body-md hover:text-primary transition-colors" href="#">Wealth Strategy</a>
    <a class="text-on-surface-variant font-body-md text-body-md hover:text-primary transition-colors" href="#">Estate Planning</a>
    <a class="text-on-surface-variant font-body-md text-body-md hover:text-primary transition-colors" href="#">Tax Efficiency</a>
    </div>
    <div class="flex flex-col gap-5 col-span-2 lg:col-span-1">
    <p class="font-label-lg text-label-lg text-on-surface uppercase tracking-widest font-bold mb-2">Contact</p>
    <a class="text-on-surface-variant font-body-md text-body-md hover:text-primary transition-colors flex items-center gap-3" href="mailto:concierge@bajajcapital.com">
    <img src="assets/icons/mail.svg" alt="mail" class="w-5 h-5 object-contain" />
                        concierge@bajajcapital.com
                    </a>
    <a class="text-on-surface-variant font-body-md text-body-md hover:text-primary transition-colors flex items-center gap-3" href="tel:1800-BAJAJ-CAP">
    <img src="assets/icons/call.svg" alt="call" class="w-5 h-5 object-contain" />
                        1800-BAJAJ-CAP
                    </a>
    </div>
    </div>
    </div>
    </footer> -->
    <script>
        // Interaction for form focus states
        const inputs = document.querySelectorAll('input, select');
        inputs.forEach(input => {
            input.addEventListener('focus', () => {
                const label = input.parentElement.querySelector('label');
                if (label) label.classList.add('text-primary');
            });
            input.addEventListener('blur', () => {
                const label = input.parentElement.querySelector('label');
                if (label) label.classList.remove('text-primary');
            });
        });
    
        // Header scroll appearance
        const header = document.querySelector('header');
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 50) {
                header.classList.add('bg-white', 'h-16', 'shadow-md');
                header.classList.remove('h-20', 'bg-white/90');
            } else {
                header.classList.remove('bg-white', 'h-16', 'shadow-md');
                header.classList.add('h-20', 'bg-white/90');
            }
        });
    
        // Intersection Observer for scroll animations
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };
    
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('opacity-100', 'translate-y-0');
                    entry.target.classList.remove('opacity-0', 'translate-y-10');
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);
    
        document.querySelectorAll('section, .performance-tile').forEach(el => {
            el.classList.add('transition-all', 'duration-700', 'opacity-0', 'translate-y-10');
            observer.observe(el);
        });
    </script>
    </div> 